import React from 'react';

import { Button } from '../../Field';
import Title from '../../Title';
import Section from '../../Section';
import Center from '../../Center';
import Text from '../../Text';
import SectionBorder from '../../../pages/Shared/SectionBorder';

import style from './style.module.css';
import Spacer from '../../Spacer';


const NoMatch = (props) => {
    const {
        label = "Home",
        link = "/dashboard",
        color = "buttonPrimary",
        title = "Oops",
        text = "We can't seem to find the page you're looking for.",
        onClick = undefined,
        showButton = true,
        showBorder = false,
    } = props;

    return (
        <Section id="noMatch">
            <Center>
                <SectionBorder showBorder={showBorder}>
                    <div className={style.noMatch}>
                        <div className={style.sectionRow}>
                            <div className={style.sectionHeader}>
                                <Title tag="h1">{title}</Title>
                            </div>
                            <Spacer />
                            <div className={style.sectionBody}>
                                <Text className={style.nomatchDisc}>{text}</Text>
                            </div>
                            {showButton === true &&
                                <>
                                    <Spacer />
                                    <div className={style.sectionFooter}>
                                        {onClick &&
                                            <Button
                                                className={style.nomatchButton}
                                                label={label}
                                                color={color}
                                                onClick={onClick}
                                            />
                                        }
                                        {!onClick &&
                                            <Button
                                                className={style.nomatchButton}
                                                link={link}
                                                label={label}
                                                color={color}
                                            />
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </SectionBorder>
            </Center>
        </Section>
    )
}

export default NoMatch